// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Gilroy/GilroyRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Gilroy/GilroyRegular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Gilroy/GilroyBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Gilroy/GilroyBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Roboto/Roboto-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Roboto/Roboto-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Roboto/Roboto-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Roboto/Roboto-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/Montserrat/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/Montserrat/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/Gilroy/GilroySemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/Gilroy/GilroySemiBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-display: normal;
  font-family: "Gilroy";
  src: local("Gilroy"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-display: swap;
  font-family: "Gilroy-Bold";
  src: local("Gilroy-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}
@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat-SemiBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-style: normal;
}
@font-face {
  font-display: swap;
  font-family: "Gilroy-SemiBold";
  src: local("Gilroy-SemiBold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  /* font-weight: 700; */
  font-style: normal;
}

body,
html {
  margin: 0;
  height: 100%;
  background-color: #faf5ec;
}

#root {
  height: 100%;
}

ul {
  padding-inline-start: 16px;
}

/*This is for the HealthyLife Website element selector css override which breaks the checkboxes*/
#widgetRoot input[type="checkbox"] {
  height: 100%;
  width: 100%;
  padding: 0;
}

img {
  max-width: inherit;
}

input[type="checkbox"].MuiSwitch-input {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;EACrB;;0DAEyD;EACzD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B;;0DAEsD;EACtD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;0DAE0D;AAC5D;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;0DACuD;AACzD;AACA;EACE,yBAAyB;EACzB,+DAAwE;EACxE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,+DAAyE;EACzE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B;;2DAE0D;EAC1D,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gGAAgG;AAChG;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":["@font-face {\n  font-display: normal;\n  font-family: \"Gilroy\";\n  src: local(\"Gilroy\"),\n    url(\"./fonts/Gilroy/GilroyRegular.woff2\") format(\"woff2\"),\n    url(\"./fonts/Gilroy/GilroyRegular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-display: swap;\n  font-family: \"Gilroy-Bold\";\n  src: local(\"Gilroy-Bold\"),\n    url(\"./fonts/Gilroy/GilroyBold.woff2\") format(\"woff2\"),\n    url(\"./fonts/Gilroy/GilroyBold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: local(\"Roboto\"),\n    url(\"./fonts/Roboto/Roboto-Regular.woff2\") format(\"woff2\"),\n    url(\"./fonts/Roboto/Roboto-Regular.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: local(\"Roboto\"), url(\"./fonts/Roboto/Roboto-Bold.woff2\") format(\"woff2\"),\n    url(\"./fonts/Roboto/Roboto-Bold.woff\") format(\"woff\");\n}\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./fonts/Montserrat/Montserrat-Regular.ttf\") format(\"truetype\");\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Montserrat-SemiBold\";\n  src: url(\"./fonts/Montserrat/Montserrat-SemiBold.ttf\") format(\"truetype\");\n  font-style: normal;\n}\n@font-face {\n  font-display: swap;\n  font-family: \"Gilroy-SemiBold\";\n  src: local(\"Gilroy-SemiBold\"),\n    url(\"./fonts/Gilroy/GilroySemiBold.woff2\") format(\"woff2\"),\n    url(\"./fonts/Gilroy/GilroySemiBold.woff\") format(\"woff\");\n  /* font-weight: 700; */\n  font-style: normal;\n}\n\nbody,\nhtml {\n  margin: 0;\n  height: 100%;\n  background-color: #faf5ec;\n}\n\n#root {\n  height: 100%;\n}\n\nul {\n  padding-inline-start: 16px;\n}\n\n/*This is for the HealthyLife Website element selector css override which breaks the checkboxes*/\n#widgetRoot input[type=\"checkbox\"] {\n  height: 100%;\n  width: 100%;\n  padding: 0;\n}\n\nimg {\n  max-width: inherit;\n}\n\ninput[type=\"checkbox\"].MuiSwitch-input {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
